<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="wrapper">
<main class="main--container">

  <app-payin></app-payin>
</main>
</div>
